import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CustomInput from 'reactstrap/es/CustomInput';
import { useLocalStorage } from '../../../Components/useLocalStorage';

const UISettings = () => {
	const [darkTheme, setDarkTheme] = useLocalStorage('isDarkTheme', false);
    return (
	<div>
		<h3>UI Settings</h3>
		<CustomInput
			type="checkbox"
			label="Dark theme"
			onChange={(e) => setDarkTheme(e.target.checked)}
			checked={darkTheme}
			id="DarkTheme"
		/>
	</div>
    );
};

export default UISettings;
